import React from "react";
import { connect } from "react-redux";

import { HubHookFormWrapper, PageContent } from "../../components";
import { getUserLocation } from "../../redux";
import { RolePermissionsTable } from "../../tables";

import OrganizationPermissionsBar from "./OrganizationPermissionsBar";
import { CreateOrganizationRole } from "../../dialogs";

export const OrganizationPermissionsContainer = ({ defaultLocation = 1 }) => {
  const onSubmit = () => {};

  return (
    <PageContent gap="15px" mediumPadding white>
      <OrganizationPermissionsBar />
      <HubHookFormWrapper
        onSubmit={onSubmit}
        sx={{ height: "100%", overflow: "hidden" }}
      >
        <RolePermissionsTable locationId={defaultLocation} />
      </HubHookFormWrapper>
      <CreateOrganizationRole />
    </PageContent>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const OrganizationPermissions = connect(mapStateToProps)(
  OrganizationPermissionsContainer
);
export default OrganizationPermissions;
